import React from 'react'
import { Banner } from './styles.style'
import BannerImg from '../../../../../assets/images/banners-cartao/banner-cartao.png'
import BannerImgMobile from '../../../../../assets/images/banners-cartao/banner-cartao-mobile.png'
import { isMobile } from '../../../../../src/helpers/window.helper'
import { routes } from '../../../../constants/routes.constants'
import Link from 'react-router-dom/Link'

import { connect } from 'react-redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { bindActionCreators } from 'redux'

const banner = isMobile() ? BannerImgMobile : BannerImg

class BannerCard extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const { ENTRAR, MUVICARD_CADASTRO, MEU_CARTAO } = routes
		const { logged, setMenuOptionPath } = this.props
		const loggedRoute =
			logged && logged.hasMuvicard ? `${MEU_CARTAO}` : `${MUVICARD_CADASTRO}`
		return (
			<Banner>
				{logged ? (
					<Link to={loggedRoute} title="Solicitar meu cartão Muvicard">
						<img
							src={banner}
							alt="Solicitar meu cartão Muvicard"
							onClick={() => {
								setMenuOptionPath(loggedRoute)
							}}
						/>
					</Link>
				) : (
					<Link to={`${ENTRAR}`} title="Fazer meu cartão muvicard">
						<img
							src={banner}
							alt="Fazer meu cartão muvicard"
							onClick={() => {
								setMenuOptionPath(`${MUVICARD_CADASTRO}`)
							}}
						/>
					</Link>
				)}
			</Banner>
		)
	}
}

const mapStateToProps = ({ site }) => ({
	menuOptionPath: site.menuOptionPath
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setMenuOptionPath: SiteCreators.menuOptionPath
		},
		dispatch
	)

export default connect(mapStateToProps, mapDispatchToProps)(BannerCard)
